/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L3_NInputs */

const en_mk_sec_pg_l3_n = /** @type {(inputs: Mk_Sec_Pg_L3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role changes, deletions, approval decisions and agent permission changes are recorded with actor and time.`)
};

const id_mk_sec_pg_l3_n = /** @type {(inputs: Mk_Sec_Pg_L3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan peran, penghapusan, keputusan approval, dan perubahan izin agen tercatat dengan pelaku dan waktunya.`)
};

/**
* | output |
* | --- |
* | "Role changes, deletions, approval decisions and agent permission changes are recorded with actor and time." |
*
* @param {Mk_Sec_Pg_L3_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l3_n = /** @type {((inputs?: Mk_Sec_Pg_L3_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L3_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l3_n(inputs)
	return en_mk_sec_pg_l3_n(inputs)
});